import { useCallback, useState } from "react";
import { Table, Button, Space, Modal, Input, notification, Tag, Spin } from "antd";
import { useRequest } from "../../../hooks";
import { searchUsers, deleteUser, resetPassword } from "../../../api/user";
import UserFilter from './Filter';
import { KeyVal } from "../../Layouts";
import UsetUpsert from "./Upsert";
import IfNotObserver from "../../common/IfNotObserver";

export default function () {
    const [showModal, setShowModal] = useState(false);
    const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [edittingRecord, setEdittingRecord] = useState<UserRecord>();
    const [newPassword, setNewPassword] = useState('');
    const [resettingRecord, setResettingRecord] = useState<UserRecord>();
    const [searchParams, setSearchParams] = useState<Partial<SearchUserParams>>({});
    const [fetchDataParams, setFetchDataParams] = useState<Partial<SearchUserParams>>();
    const [pagination, setPagination] = useState({
        pageNum: 1,
        pageSize: 10,
    });
    const fetchData = useCallback(() => {
        return searchUsers({
            ...fetchDataParams,
            ...pagination,
        })
    }, [fetchDataParams, pagination]);
    const { data, loading } = useRequest(fetchData);
    const onSearch = () => {
        setPagination({
            ...pagination,
            pageNum: 1,
        })
        setFetchDataParams({
            ...searchParams,
        })
    };
    const newPasswordValid = !!newPassword; // TODO: check pattern
    return (
        <Spin spinning={deleting || updating}>
            <Space style={{ display: 'flex', justifyContent: 'space-between' }}>
                <UserFilter values={searchParams} onChange={setSearchParams} onSearch={onSearch} />
                <IfNotObserver>
                    <Button type="primary" onClick={() => setShowModal(true)}>创建用户</Button>
                </IfNotObserver>
            </Space>
            <br /> <br />
            <Table
                pagination={{
                    pageSize: pagination.pageSize,
                    current: pagination.pageNum,
                    total: data?.total,
                    onChange: (pageNum, pageSize) => {
                        setPagination({
                            ...pagination,
                            pageSize,
                            pageNum
                        })
                    }
                }}
                columns={[
                    {
                        dataIndex: 'userId',
                        title: 'ID',
                    },
                    {
                        dataIndex: 'name',
                        title: '姓名',
                    },
                    {
                        dataIndex: 'phone',
                        title: '手机号码',
                    },
                    {
                        dataIndex: 'email',
                        title: '邮箱',
                    },
                    {
                        dataIndex: 'roles',
                        title: '角色',
                        render: (roles: UserRole[]) => {
                            return roles.map(i => i.description).join(', ')
                        }
                    },
                    {
                        dataIndex: 'organizations',
                        title: '组织',
                        render: (organizations: UserOrganization[]) => {
                            return organizations.map(i => i.name).join(', ')
                        }
                    },
                    {
                        dataIndex: 'isActive',
                        title: '账号状态',
                        render: (isActive) => {
                            return isActive === 1 ? <Tag color='green'>正常</Tag> : <Tag color='red'>禁用</Tag>
                        }
                    },
                    {
                        dataIndex: 'actions',
                        title: '操作',
                        render: (_, row) => {
                            return (
                                <IfNotObserver>

                                <Space size="middle">
                                    <a onClick={e => {
                                        e.preventDefault()
                                        setEdittingRecord(row)
                                        setShowModal(true)
                                    }}>编辑</a>
                                    <a onClick={e => {
                                        e.preventDefault()
                                        Modal.confirm({
                                            title: '确定删除用户? 此操作不可撤销',
                                            onOk: () => {
                                                setDeleting(true)
                                                deleteUser(row.userId)
                                                    .then(() => {
                                                        notification.success({ message: '删除成功' })
                                                        setPagination({
                                                            ...pagination,
                                                            pageNum: 1
                                                        })
                                                    }).catch(() => {
                                                        notification.error({ message: '删除失败, 请重试' })
                                                    })
                                                    .finally(() => setDeleting(false))
                                            }
                                        })
                                    }}>删除</a>
                                    <a onClick={e => {
                                        e.preventDefault()
                                        setShowResetPasswordModal(true)
                                        setResettingRecord(row)
                                    }}>重置密码</a>
                                </Space>
                                </IfNotObserver>
                            )
                        }
                    }
                ]}
                loading={loading}
                dataSource={data?.data}
            />
            <Modal destroyOnClose title='创建/编辑用户' open={showModal} footer={null} onCancel={() => {
                setShowModal(false)
                setEdittingRecord(undefined);
            }}>
                <br />
                <UsetUpsert initialValues={edittingRecord} onComplete={() => {
                    setPagination({
                        ...pagination,
                        pageNum: 1
                    });
                    setEdittingRecord(undefined)
                    setShowModal(false)
                }} />
            </Modal>

            <Modal
                title="重置用户密码"
                open={showResetPasswordModal && !!resettingRecord}
                footer={null}
                onCancel={() => setShowResetPasswordModal(false)}
            >
                <KeyVal name="姓名" value={resettingRecord?.name} />
                <KeyVal name="手机号码" value={resettingRecord?.phone} />
                <KeyVal name="邮箱" value={resettingRecord?.email || '-'} />
                <div>
                    <Input.Password style={{ width: 'auto' }} value={newPassword}
                        onChange={e => {
                            setNewPassword(e.target.value)
                        }}
                        placeholder="请输入新密码" />
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button disabled={!newPasswordValid} type='primary' onClick={() => {
                        setUpdating(true)
                        resetPassword(resettingRecord!.userId, newPassword)
                            .then(() => {
                                notification.success({ message: '重置成功' })
                                setResettingRecord(undefined)
                                setShowResetPasswordModal(false)
                                setNewPassword('')
                            })
                            .catch(() => {
                                notification.error({ message: '重置失败, 请重试' })
                            })
                            .finally(() => setUpdating(false))
                    }}>重置密码</Button>
                </div>
            </Modal>
        </Spin>
    )
}